import './i18n';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App, { SUPPORTED_LANGUAGES } from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';

// Get the default language based on domain
const getDefaultLanguage = () => {
    const isPLDomain = window.location.hostname.endsWith('.pl');
    return isPLDomain ? 'pl' : 'en';
};

// Create routes for each supported language
const routes = SUPPORTED_LANGUAGES.map(lang => ({
    path: `/${lang}/*`,
    element: <App defaultLanguage={lang} />,
}));

// Add root redirect
routes.push({
    path: '/',
    element: <App defaultLanguage={getDefaultLanguage()} />
    //element: <Navigate to={`/${getDefaultLanguage()}`} replace />,
});

// Add catch-all redirect
routes.push({
    path: '*',
    element: <Navigate to={`/${getDefaultLanguage()}`} replace />,
});

const router = createBrowserRouter(routes);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><RouterProvider router={router} /></React.StrictMode>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
